import axios from 'axios'
import { get } from 'ol/proj'
import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'
import ProjectionDef from '../Projection/ProjectionDef'
import wkt from 'wkt-parser'
/** 
 * @type {String} EPSG 官网
 */
const epsg = "https://epsg.io/"
/**
 * 当前ol中支持的投影坐标
 */
const container_ = {}
const wktNames_ = {}
let hasInit_=false
const ProjectionUtil = {
  //初始化投影信息
  init () {
    if (hasInit_) {
      return
    }
    
    Object.keys(ProjectionDef).forEach(x => {
      //已注册的坐标系跳过
      if (container_[x]) {
        return
      }
      this.registerWktName(x)
      //有def4值，没有直接从ol中获取
      if (ProjectionDef[x].proj4) {
        this.registerProj4(x, ProjectionDef[x].proj4, ProjectionDef[x].wkt)
      } else {
        const proj = get(x)
        if (proj) {
          container_[x] = proj
          this.registerWktName(x, ProjectionDef[x].wkt)
        }
      }
    })
    hasInit_ = true
    console.info("Projection: ol支持坐标系", Object.keys(container_).join(","))
  },
  getProjections () {
    //浅复制容器中所有坐标系信息
    return { ...container_ }
  },
  /**
   * Code获得坐标系信息
   * @param {String} code 
   * @returns ol.proj
   */
  get (code) {
    const epsgCode = this.getEPSGCode(code)
    return container_[epsgCode]
  },
  /**
   * 添加新的坐标系信息到ol
   * @param {String} code 
   * @param {String} proj4def 
   */
  register (code, proj4def, wktName = "") {
    const epsgCode = this.getEPSGCode(code)
    if (container_[epsgCode]) {
      console.error(epsgCode, "已注册，已覆盖原坐标系信息！")
    }
    this.registerProj4(epsgCode, proj4def, wktName)
  },
  registerProj4 (epsgCode, proj4def, wktName) {
    this.registerWktName(epsgCode, wktName)
    proj4.defs(epsgCode, proj4def)
    register(proj4)
    container_[epsgCode] = get(epsgCode)
  },
  /**
   * 获得标准的EPSG Code字符串
   * @param {String} code 
   * @returns 
   */
  getEPSGCode (code) {
    let codeStr = (typeof code) === 'number' ? code + "" : code.toUpperCase()
    if (codeStr.indexOf("EPSG") < 0) {
      codeStr = "EPSG:" + codeStr
    }
    return codeStr
  },
  /**
   * 搜索投影信息
   * @param {*} queryWord 搜查文字
   * @param {*} callback 结果回调函数
   */
  search (queryWord, callback) {
    const searchUrl = epsg + '?format=json&q=' + queryWord
    axios.get(searchUrl).then(res => {
      callback(res.data)
    })
  },
  /**
   * 获得投影code查询结果epsg网址
   * @param {String | Number} code 
   * @return {*} 网址
   */
  getPrjCodeUrl (code) {
    return epsg + code
  },
  /**
   * 获得指定投影epsg坐标转换的网址
   * @param {String | Number} code 
   * @returns 
   */
  getPrjTransformUrl (code) {
    return epsg + 'transform#s_srs=' + code + '&t_srs=4326'
  },

  registerWktName (epsgCode, wktName) {
    if (wktName) {
      wktNames_[epsgCode] = wktName
    }
  },

  findEpsgCodeByWkt (wktStr) {
    const wktName = wkt(wktStr).name
    let epsgCode = ""
    Object.keys(wktNames_).forEach(code => {
      if (wktName === wktNames_[code]) {
        epsgCode = code
        return true
      }
    })
    return epsgCode
  }
}
export default ProjectionUtil
